import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

const KycFailedPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ maxWidth: 720, margin: "40px auto", padding: "0 16px" }}>
      <Result
        status="warning"
        title="Sorry, we're unable to verify your identity."
        extra={
          <Button type="primary" onClick={() => navigate("/kyc")}>
            Try again
          </Button>
        }
      />
    </div>
  );
};

export default KycFailedPage;
